import * as React from 'react';

function SvgCalendarEventsStroke(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.327 5a.7.7 0 111.4 0v1.814h6.142V5a.7.7 0 111.4 0v1.814h3.64c.766 0 1.387.62 1.387 1.388v14.963c0 .767-.62 1.388-1.388 1.388H6.688c-.767 0-1.388-.62-1.388-1.388V8.202c0-.767.62-1.388 1.388-1.388h3.64V5zm7.542 3.214v1.814a.7.7 0 101.4 0V8.214h3.627v4.884H6.7V8.214h3.627v1.814a.7.7 0 101.4 0V8.214h6.142zm5.027 6.284v8.655H6.7v-8.655h16.196z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgCalendarEventsStroke;
